import type { PopoverListItem } from '@o2d/popover-list';

/**
 * Adapter interface matching the common fields of both ComboboxItem variants.
 * Used by toPopoverListItems() to decouple from the concrete ComboboxItem types.
 */
export interface ComboboxItemLike {
    id: unknown;
    title: string;
    type?: 'normal' | 'divider' | 'link';
    icon?: string;
    disabled?: boolean;
    hidden?: boolean;
    color?: string;
    payload?: unknown;
}

/**
 * Maps ComboboxItem-like objects to PopoverListItem format.
 * Handles title→label, type 'normal'→'item', and String(id) conversion.
 */
export function toPopoverListItems(items: ComboboxItemLike[]): PopoverListItem[] {
    return items.map((item) => ({
        id: String(item.id),
        label: item.title,
        type: mapType(item.type),
        icon: item.icon,
        disabled: item.disabled,
        hidden: item.hidden,
        color: item.color,
        payload: item.payload,
    }));
}

/** Maps ComboboxItem type to PopoverListItem type. 'normal' and undefined become 'item'. */
function mapType(type: ComboboxItemLike['type']): PopoverListItem['type'] {
    if (type === 'divider' || type === 'link') return type;
    return 'item';
}
